/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { ArrowRight } from '@carbon/react/icons';
import { ClickableTile, Tag } from 'carbon-components-react';
import React from 'react';
import { useIntl } from 'react-intl';

import { ServiceDeskLogo } from '../../helpers/serviceDeskHelpers';
import { channelTypeToChannelName } from '../../util/channelTypes';
import { ServiceDesk } from './messages';

import './ServiceDeskCard.scss';

interface ServiceDeskCardProps {
  /**
   *
   */
  serviceDesk?: string;
  /**
   *
   */
  parentChannelType?: string;
  /**
   *
   */
  onClick: () => void;
  /**
   *
   */
  readOnly: boolean;
  /**
   *
   */
  hideLogo?: boolean;
  /**
   * isBeta boolean flag determines if the ServiceDesk is of beta feature
   */
  isBeta?: boolean;
}

export const ServiceDeskCard = ({
  serviceDesk,
  parentChannelType,
  onClick,
  readOnly,
  hideLogo,
  isBeta
}: ServiceDeskCardProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <ClickableTile
      disabled={readOnly}
      id={'service-desk-radio-' + serviceDesk}
      className="ServiceDesk__tile"
      onClick={e => {
        if (!readOnly) {
          e.preventDefault();
          onClick();
        }
      }}>
      <ServiceDeskLogo
        parentChannelType={parentChannelType}
        serviceDeskType={serviceDesk}
        showTitle={false}
        hideLogo={hideLogo}
      />
      {isBeta && (
        <>
          <Tag
            type="cyan"
            title={t(ServiceDesk.beta)}
            className="ServiceDesk__tile-beta">
            {t(ServiceDesk.beta)}
          </Tag>
        </>
      )}
      <p className="ServiceDesk__tile-title">
        {channelTypeToChannelName[serviceDesk]}
      </p>
      <div
        title={`${t(ServiceDesk.rightArrowLabel)}${t(ServiceDesk.logoLabel)}`}
        aria-hidden="true">
        <ArrowRight
          size={24}
          aria-label={t(ServiceDesk.rightArrowLabel)}
          aria-hidden="true"
          className="ServiceDesk__tile-arrow"
        />
      </div>
    </ClickableTile>
  );
};
